












export default {
    name: 'rank-update',
    props: {
        change: {
            type: String,
            default: null,
            validator(value) {
                return [
                    'up',
                    'down',
                    null,
                ].indexOf(value) !== -1;
            },
        },
    },

    computed: {
        hasChange() {
            return ['up', 'down'].includes(this.change);
        },
    },
};
